<template>
    <div class="owner">
        <div class="owner__photo">
            <a
                :href="`/adverts/posted-by/${agent.slug}`"
                class="owner__avatar"
                title="View all users's adverts"
            >
                <span class="owner__initials">
                    {{ agent.public_name_initials }}
                </span>
                <img v-if="agent.image_url" :src="agent.image_url" :alt="agent.public_name_initials">
            </a>
        </div>
        <h5 class="mb-0">
            {{ agent.public_name }}
        </h5>
        <a :href="`/my-adverts/?agent=${agent.uuid}`" class="owner__adverts">
            <strong>{{ agent.ads_count }} Adverts</strong>
        </a>
        <p class="text-center">
            <span class="owner__email mx-auto">{{ agent.email }}</span>
            {{ agent.public_phone_number_e164 }}
            <span
                v-if="agent.public_phone_number_e164"
                class="info-note"
                :class="agent.has_verified_phone_number ? 'info-note--success' : 'info-note--danger'"
                v-text="agent.has_verified_phone_number ? '✓' : 'x'"
            ></span>
        </p>
        <p class="text-center">
            {{ agent.conversations_involved_in_count }} conversation(s)
        </p>
        <div class="owner__actions">
            <template v-if="agent.is_active">
                <button
                    type="button"
                    class="btn btn--xs btn--primary"
                    @click.prevent="showAgentSettingsModal = true"
                >
                    Settings
                </button>
                <a
                    class="btn btn--xs btn--primary"
                    :href="`/agents/chat/${agent.uuid}`"
                    v-if="agent.conversations_involved_in_count"
                >
                    Show Chat
                </a>
                <button
                    type="button"
                    class="btn btn--xs btn--secondary"
                    @click.prevent="showDisableUserModal = true"
                >
                    Disable
                </button>
            </template>
            <template v-else>
                <button
                    type="button"
                    class="btn btn--xs btn--primary"
                    @click.prevent="onEnable(agent.uuid)"
                >
                    Enable
                </button>
                <button
                    type="button"
                    class="btn btn--xs btn--secondary"
                    @click.prevent="showDeleteUserModal = true"
                >
                    Delete
                </button>
            </template>
        </div>

        <AgentSettingsModal
            :show-modal="showAgentSettingsModal"
            :agent="agent"
            @close="showAgentSettingsModal = false"
        />

        <DisableUserModal
            :show-modal="showDisableUserModal"
            :agent="agent"
            @close="showDisableUserModal = false"
        />

        <DeleteUserModal
            :show-modal="showDeleteUserModal"
            :agent="agent"
            @close="showDeleteUserModal = false"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import DisableUserModal from '@components/UserAgents/partials/DisableUserModal.vue';
import DeleteUserModal from '@components/UserAgents/partials/DeleteUserModal.vue';
import AgentSettingsModal from '@components/UserAgents/partials/AgentSettingsModal.vue';

export default {
    components: {
        DisableUserModal,
        DeleteUserModal,
        AgentSettingsModal,
    },
    props: {
        agent: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showDisableUserModal: false,
            showDeleteUserModal: false,
            showAgentSettingsModal: false,
        };
    },
    methods: {
        ...mapActions('user', ['enableAgent']),
        async onEnable() {
            await this.enableAgent({ uuid: this.agent.uuid });
            window.showToastSuccess('Agent enabled.');
            this.$root.$emit('refilter-agents');
        },
    },
};
</script>
